import { useGetCommodities } from '../../../../FunctionalApps/commodities/ProcessedFluidCommodities.queries';

export const ContractGenerationStatus = {
    Draft: 'draft',
    ContractDetails: 'contractDetails',
    ContractTerms: 'contractTerms',
    PricingAndCharges: 'pricingAndCharges',
    SettlementTermsAndCriteria: 'settlementTermsAndCriteria',
    UploadDocuments: 'documentUpload',
    Review: 'review',
    Cancelled: 'cancelled',
    Complete: 'complete',
};

export const getStepFromContractStatus = (status) => {
    switch (status) {
        case ContractGenerationStatus.ContractDetails:
            return 0;
        case ContractGenerationStatus.ContractTerms:
            return 1;
        case ContractGenerationStatus.PricingAndCharges:
            return 2;
        case ContractGenerationStatus.SettlementTermsAndCriteria:
            return 3;
        case ContractGenerationStatus.UploadDocuments:
            return 4;
        case ContractGenerationStatus.Review:
            return 5;
        default:
            return 0;
    }
};

export const getContractStatusFromStep = (step) => {
    switch (step) {
        case 0:
            return ContractGenerationStatus.ContractDetails;
        case 1:
            return ContractGenerationStatus.ContractTerms;
        case 2:
            return ContractGenerationStatus.PricingAndCharges;
        case 3:
            return ContractGenerationStatus.SettlementTermsAndCriteria;
        case 4:
            return ContractGenerationStatus.UploadDocuments;
        case 5:
            return ContractGenerationStatus.Review;
        default:
            return ContractGenerationStatus.Cancelled;
    }
};

export const convertExpressionToText = (expression) => {
    switch (expression) {
        case 'gte':
            return 'Greater Than or Equal To';
        case 'lte':
            return 'Less Than or Equal To';
        case 'gt':
            return 'Greater Than';
        case 'lt':
            return 'Less Than';
        case 'eq':
            return 'Equal To';
        case 'range':
            return 'Range is';
        default:
            return '';
    }
};

export const multiplierOptions = [
    { name: 'Multiply (x)', id: 'multiply' },
    { name: 'Divide (/)', id: 'divide' },
    { name: 'Add (+)', id: 'add' },
    { name: 'Subtract (-)', id: 'subtract' },
];

export const getCommoditiesWithRawMilk = () => {
    const { isLoading, data } = useGetCommodities({ queryParams: { where: { disabled: { eq: false }, deleted_at: { eq: null } } } });
    const base = Array.isArray(data) ? data : [];
    const rawMilkCommodity = { type: 'raw_milk', name: 'Raw Milk' };
    const commodities = [rawMilkCommodity, ...base];
    return { commodities, isLoading };
};
